<div class="d-flex" id="wrapper">

  <admin-sidebar id="admin-sidebar"></admin-sidebar>

  <div id="page-content-wrapper">

    <admin-navigation></admin-navigation>

    <div class="container-fluid">
      <div class="mt-5 mt-md-5 mb-3 mb-md-3">
        <h3 class="font-weight-bold page-title">Device Orders</h3>
      </div>
      <div class="row mb-4 mb-md-4">
        <!-- <div class="form-group hidden">
          <div class="input-group">
            <input
              name="datepicker"
              class="form-control"
              ngbDatepicker
              #datepicker="ngbDatepicker"
              [autoClose]="'outside'"
              (dateSelect)="onDateSelection($event)"
              [displayMonths]="2"
              [dayTemplate]="t"
              outsideDays="hidden"
              [startDate]="fromDate!"
              readonly
            >
            <ng-template #t let-date let-focused="focused">
              <span
                class="custom-day"
                [class.focused]="focused"
                [class.range]="isRange(date)"
                [class.faded]="isHovered(date) || isInside(date)"
                (mouseenter)="hoveredDate = date"
                (mouseleave)="hoveredDate = null"
              >
                {{ date.day }}
              </span>
            </ng-template>
          </div>
        </div>
        <div class="form-group">
          <div class="input-group">
            <input
              class="form-control"
              placeholder="Date from"
              name="dpFromDate"
              autocomplete="off"
              [value]="formatter.format(fromDate)"
              (input)="fromDate = validateInput(fromDate, dpFromDate.value)"
              (click)="datepicker.toggle()"
              id="dateInputFrom"
              readonly
            >
            <div class="input-group-append clear-date">
              <span class="input-group-text" (click)="clearDateFrom()"><i class="fa fa-times"></i> </span>
            </div>
          </div>
        </div>
        <div class="form-group ml-2">
          <div class="input-group">
            <input
              class="form-control"
              placeholder="Date to"
              name="dpToDate"
              autocomplete="off"
              [value]="formatter.format(toDate)"
              (input)="toDate = validateInput(toDate, dpToDate.value)"
              (click)="datepicker.toggle()"
              id="dateInputTo"
            >
            <div class="input-group-append clear-date">
              <span class="input-group-text" (click)="clearDateTo()"><i class="fa fa-times"></i> </span>
            </div>
          </div>
        </div> -->

        <div class="form-group col-md-2">
          <div class="input-group">
            <input
              class="form-control"
              placeholder="Date from"
              name="fromDate"
              ngbDatepicker
              (click)="d.toggle()"
              (dateSelect)="onDateFromSelection($event)"
              #d="ngbDatepicker"
              id="dateInputFrom"
              [(ngModel)]="dpFromDate"
              readonly>
            <div class="input-group-append clear-date">
              <span class="input-group-text" (click)="clearDateFrom()"><i class="fa fa-times"></i> </span>
            </div>
          </div>
        </div>

        <div class="form-group col-md-2">
          <div class="input-group">
            <input
              class="form-control"
              placeholder="Date to"
              name="toDate"
              ngbDatepicker
              (click)="f.toggle()"
              (dateSelect)="onDateToSelection($event)"
              #f="ngbDatepicker"
              id="dateInputTo"
              [(ngModel)]="dpToDate"
              readonly
            >
            <div class="input-group-append clear-date">
              <span class="input-group-text" (click)="clearDateTo()"><i class="fa fa-times"></i> </span>
            </div>
          </div>
        </div>

        <div class="col-md-2">
          <input type="text" class="form-control" placeholder="Search" #searchDeviceOrderInput>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 table-responsive">
          <table class="table table-borderless">
            <colgroup>
              <col width="25%">
              <col width="10%">
              <col width="20%">
              <col width="30%">
              <col width="5%">
              <col width="10%">
            </colgroup>
            <thead>
              <tr>
                <th class="text-left">Order Date</th>
                <th class="text-center">Order #</th>
                <th class="text-left">Order By</th>
                <th class="text-left">Delivery Address</th>
                <th class="text-center">Dispatched</th>
                <th class="text-center">Payment</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let device of deviceOrders">
                <td class="text-left align-middle">{{ device?.requested_on * 1000 | date: 'dd LLL yyyy h:mma' : '+1200' }}</td>
                <td class="text-center align-middle">{{ device?.id }}</td>
                <td class="align-middle">{{ device.user?.fullname }}</td>
                <td class="align-middle">{{ device?.fullAddress}}</td>
                <td class="text-center align-middle">
                  <label class="checkboxcontainer" *ngIf="device?.payment_received == 1">
                    <input
                      type="checkbox"
                      [id]="device.id"
                      [checked]="(device.status) === 'processed'"
                      (click)="markDispatched($event)"
                    >
                    <span class="device-checkmark" *ngIf="device?.payment_received == 1"></span>
                  </label>
                </td>
                <td class="text-center align-middle">
                  <i class="fa fa-check text-success" *ngIf="device?.payment_received == 1; else noPayment"></i>
                  <ng-template #noPayment>
                    <i class="fa fa-times text-danger"></i>
                  </ng-template>
                </td>
              </tr>
              <tr *ngIf="!loading && deviceOrders?.length == 0">
                <td class="align-middle text-center" colspan="6">No Record Found</td>
              </tr>
            </tbody>
          </table>

        </div>
      </div>

      <!-- Pagination -->
      <nav *ngIf="deviceOrders?.length > 0">
        <ul class="pagination justify-content-center">
          <li
            class="page-item"
            [ngClass]="{'disabled': currentPage == 1}"
            (click)="paginate(currentPage - 1)"
          >
            <a class="page-link" tabindex="-1">Previous</a>
          </li>
          <li
            class="page-item"
            *ngFor="let link of pageLinks"
            [ngClass]="{'active': currentPage == link}"
            (click)="paginate(link)"
          >
            <a class="page-link">{{ link }} <span class="sr-only" *ngIf="currentPage == link">(current)</span></a>
          </li>
          <li
            class="page-item"
            [ngClass]="{'disabled': currentPage == lastPage}"
            (click)="paginate(currentPage + 1)"
          >
            <a class="page-link">Next</a>
          </li>
        </ul>
      </nav>
      <!-- End of Pagination -->

    </div>

    <!-- Modal Loader -->
    <modal-loader [modalText]="modalText"></modal-loader>

  </div>

</div>
